(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewSalesReport.controller:CrewSalesReportCtrl
	 *
	 * @description
	 *
	 */
	angular.module('crewSalesReport').controller('CrewSalesReportCtrl',
			CrewSalesReportCtrl);

	function CrewSalesReportCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'CrewSalesReportCtrl';

		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				destination : null,
				flightNo : null,
				crewType : null,
				crewId : null
			},
			masterList : {
				airportList : [],
				crewTypeList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchCrewSalesReport(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search Crew Sales Report
		function searchCrewSalesReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'crewsales_report.rptdesign', getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			if (!!param.flightNo) {
				searchParamMap["flightNo"] = param.flightNo;
			}
			if (!!param.destination && !!param.destination.airPortCode) {
				searchParamMap["destination"] = param.destination.airPortCode;
			}
			if (!!param.crewType && !!param.crewType.crewTypeCode) {
				searchParamMap["crewType"] = param.crewType.crewTypeCode;
			}
			if (!!param.crewId) {
				searchParamMap["crewId"] = param.crewId;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				return true;
			}
		}

		(function() {
			// load airport list
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function(error) {
				console.log('Airport List retrieval error!!!');
			});

			// crew type codes
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
				vm.model.masterList.crewTypeList = crewTypeList;
			}, function() {
				console.log('Crew Type list retrieval error');
			});

		})();
	}
}());
